import { keyframes } from '@emotion/react';
import Box from '@mui/material/Box';
import { useTheme } from '@mui/material/styles';

const spin = keyframes`
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
`;

export function GradientSpinner({ size = 48 }) {
  const theme = useTheme();
  const primaryColor = theme.palette.primary.main;
  const secondaryColor = theme.palette.secondary.main;

  return (
    <Box
      sx={{
        width: size,
        height: size,
        borderRadius: '50%',
        background: `conic-gradient(from 0deg, transparent 0%, ${primaryColor} 25%, ${secondaryColor} 50%, transparent 50%)`,
        mask: 'radial-gradient(farthest-side, transparent calc(100% - 4px), #000 calc(100% - 4px))',
        WebkitMask: 'radial-gradient(farthest-side, transparent calc(100% - 4px), #000 calc(100% - 4px))',
        animation: `${spin} 1s linear infinite`,
      }}
    />
  );
}

export function Loading({ fullScreen = false, size = 48 }) {
  if (fullScreen) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh' }}>
        <GradientSpinner size={size} />
      </Box>
    );
  }

  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}>
      <GradientSpinner size={size} />
    </Box>
  );
}
